export default __webpack_public_path__ + "static/media/avatar_mei_ling7.c807d64f.mp3";